export default __webpack_public_path__ + "assets/images/4f8e60cd49592813774b7ff3fffe4c5e.svg";